<div *ngIf="customizations$ | async as customizations; else loading" class="flex flex-col">
  <div class="flex justify-between items-center px-4 pt-4">
    <h2 class="nomargin">Customize Statement</h2>
    <sbnb-close (click)="closed.emit()"></sbnb-close>
  </div>
  <p class="max-w-80 px-4">Customizations will be applied to all open statements for {{ data.propertyName }}.</p>
  <form [formGroup]="customizationsForm" class="p-4">
    <div class="flex flex-col gap-4">
      <strong>Headline</strong>
      <section class="flex flex-col" formGroupName="headline">
        <mat-checkbox formControlName="property_name">Property Name</mat-checkbox>
        <mat-checkbox formControlName="address">Property Address</mat-checkbox>
      </section>
      <mat-error *ngIf="customizationsForm.get('headline')?.errors?.['groupMin']">
        At least one headline field must be selected
      </mat-error>
      <mat-divider></mat-divider>
      <div class="flex items-center justify-between gap-3">
        <strong>Manager</strong>
        <a
          [routerLink]="['/settings/brands']"
          (click)="closed.emit()"
          class="text-sm link-muted flex gap-1 items-center ml-2">
          <sbnb-icon [size]="16" icon="cog"></sbnb-icon>
          <span>Configure brand</span>
        </a>
      </div>
      <section class="flex flex-col" formGroupName="brand_settings">
        <div class="flex flex-col gap-1">
          <mat-checkbox formControlName="brand_info">Brand info</mat-checkbox>
        </div>
        <mat-checkbox formControlName="personal_info">Personal info</mat-checkbox>
      </section>
      <mat-error *ngIf="customizationsForm.get('brand_settings')?.errors?.['groupMin']">
        At least one manager field must be selected
      </mat-error>
      <mat-divider></mat-divider>
      <strong>Reservation Columns</strong>
      <section class="flex flex-col" formGroupName="reservation_columns">
        <mat-checkbox formControlName="reservation_code">Reservation Code</mat-checkbox>
        <mat-checkbox formControlName="guest_first_name">Guest First Name</mat-checkbox>
        <mat-checkbox formControlName="guest_full_name">Guest Full Name</mat-checkbox>
      </section>
      <mat-error *ngIf="customizationsForm.get('reservation_columns')?.errors?.['groupMin']">
        At least one reservation column must be selected
      </mat-error>
      <mat-error *ngIf="customizationsForm.get('reservation_columns')?.errors?.['mutuallyExclusive']">
        Guest First Name and Guest Full Name cannot be selected at the same time
      </mat-error>
      <mat-divider></mat-divider>
      <strong>Fee Columns</strong>
      <section class="flex flex-col" formGroupName="fee_columns">
        <mat-checkbox formControlName="rental_commissions">Rental Commissions</mat-checkbox>
        <mat-checkbox formControlName="fees_sum">Total Fees</mat-checkbox>
        <mat-checkbox formControlName="host_service_fee">Host Service Fee</mat-checkbox>
        <mat-checkbox formControlName="cleaning_fee">Cleaning Fee</mat-checkbox>
        <mat-checkbox formControlName="extra_guest_fee">Extra Guest Fee</mat-checkbox>
        <mat-checkbox formControlName="linen_fee">Linen Fee</mat-checkbox>
        <mat-checkbox formControlName="management_fee">Management Fee</mat-checkbox>
        <mat-checkbox formControlName="uncategorized_revenue">Uncategorized Revenue</mat-checkbox>
        <mat-checkbox formControlName="pet_fee">Pet Fee</mat-checkbox>
        <mat-checkbox formControlName="resort_fee">Resort Fee</mat-checkbox>
        <mat-checkbox formControlName="community_fee">Community Fee</mat-checkbox>
        <mat-checkbox formControlName="upsell">Upsell</mat-checkbox>
        <mat-checkbox formControlName="flat_fees">Flat Fees</mat-checkbox>
      </section>
    </div>
  </form>

  <div class="flex gap-3 mt-8 sticky bottom-0 border-t border-smoke bg-white p-4">
    <sbnb-button type="secondary" label="Cancel" (clicked)="closed.emit()" data-testid="cancel-button"></sbnb-button>

    <sbnb-button
      [loading]="saving$ | async"
      [disabled]="customizationsForm.invalid || (saving$ | async)"
      label="Save"
      (clicked)="saveCustomizations()"
      data-testid="save-button"></sbnb-button>
  </div>
</div>
<ng-template #loading>
  <sbnb-loading-spinner></sbnb-loading-spinner>
</ng-template>
